var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',[_c('vue-apex-charts',{key:_vm.key,attrs:{"type":"bar","height":_vm.height,"options":_vm.extractedData.chartOptions,"series":_vm.extractedData.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }